import { createAction, props } from '@ngrx/store';

export const login = createAction('[Common Auth] Login');
export const logout = createAction('[Common Auth] Logout');
export const userAuthenticated = createAction(
  '[Common Auth] User Authenticated',
  props<{ isInitializingImpersonation?: boolean }>()
);
export const displaySessionExpirePage = createAction('[Common Auth] Display Session Expire Page');
